
export const themeVariables = {
    alpha: {
        buttonHover: 0.8,
        formDefault: 0.5
    }
}